export default function isPlaceholderEmail(email) {
  return email?.includes("example.net");
}